// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary_button-module--primary--3z0pu"};